import { styled } from "goober";

export const CountBadge = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 4px;
  margin: -2px 0;
  color: var(--text-primary);
  background: var(--alpha8);
  border-radius: 14px;
`;
